module.exports = __webpack_public_path__ + "img/not_data.1d2ca11e.png";